import Button from "../../../components/base/Button.tsx";
import { Link } from 'react-router-dom';

export default function EventsContentSection() {
  return (
    <section className="py-6 md:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col sm:flex-row justify-center gap-4 md:gap-24">
            <Link to="/events-children">
              <Button
                  size="lg"
                  variant="green"
                  className="whitespace-nowrap px-8 py-4 rounded-full"
              >
                Plan Kids Party
              </Button>
            </Link>
            <Link to="/events-adults">
              <Button
                  size="lg"
                  variant="green"
                  className="whitespace-nowrap px-8 py-4 rounded-full"
              >
                Plan Adult Party
              </Button>
            </Link>
          </div>
      </div>
    </section>
  );
}